import TextField from "@/components/UI/TextField/TextField";
import classNames from "classnames";
import Radio from "@/components/UI/Radio/Radio";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFillDrip, faInputText, faPaintbrush } from "@fortawesome/pro-regular-svg-icons";
import { ButtonCreatorConfig } from "./utils";
import Simulator from "./Simulator";
import ColorPickerTextField from "@/components/UI/TextField/ColorPickerTextField";

interface StylePageProps extends React.HTMLAttributes<HTMLElement> {
  onSettingsChange?: (nextSettings: ButtonCreatorConfig) => void;
  section: any;
  settings?: ButtonCreatorConfig;
}

const StylePage = ({ className, onSettingsChange, section, settings, ...props }: StylePageProps) => {
  return (
    <div className={classNames("flex divide-x", className)} {...props}>
      <div className="w-2/3 divide-y">
        <div className="flex flex-col divide-y" {...props}>
          <div className="flex gap-12 p-12">
            <div className="flex flex-1 gap-4">
              <FontAwesomeIcon className="fa-fw text-2xl text-vpBlue-500" icon={faInputText} />
              <div className="flex flex-1 flex-col gap-4">
                <div className="flex flex-1 flex-col gap-2">
                  <label htmlFor={section?.ButtonLabelTextField?.Name} className="font-bold">
                    {section?.ButtonLabelTextField?.Label}
                  </label>
                  <div className="text-vpGray-700">{section?.ButtonLabelTextField?.HelperText}</div>
                </div>
                <TextField
                  id={section?.ButtonLabelTextField?.HtmlId}
                  name={section?.ButtonLabelTextField?.Name}
                  onChange={(event) => {
                    onSettingsChange?.({
                      buttonLabel: event.currentTarget.value,
                    });
                  }}
                  placeholder={section?.ButtonLabelTextField?.Placeholder}
                  size="large"
                  value={settings?.buttonLabel}
                />
              </div>
            </div>
            <div className="flex flex-1 gap-4">
              <FontAwesomeIcon className="fa-fw text-2xl text-vpBlue-500" icon={faPaintbrush} />
              <div className="flex flex-1 flex-col gap-4">
                <div className="flex flex-1 flex-col gap-2">
                  <label htmlFor={section?.ButtonColorTextField?.Name} className="font-bold">
                    {section?.ButtonColorTextField?.Label}
                  </label>
                  <div className="text-vpGray-700">{section?.ButtonColorTextField?.HelperText}</div>
                </div>
                <div className="relative">
                  <ColorPickerTextField
                    id={section?.ButtonColorTextField?.HtmlId}
                    name={section?.ButtonColorTextField?.Name}
                    onChange={(event) => {
                      onSettingsChange?.({
                        buttonColor: event.currentTarget.value,
                      });
                    }}
                    onColorPickerChange={(value) => {
                      onSettingsChange?.({
                        buttonColor: value,
                      });
                    }}
                    placeholder={section?.ButtonColorTextField?.Placeholder}
                    size="large"
                    value={settings?.buttonColor}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="p-12">
            <div className="flex flex-1 gap-4">
              <FontAwesomeIcon className="fa-fw text-2xl text-vpBlue-500" icon={faFillDrip} />
              <div className="flex flex-1 flex-col gap-4">
                <div className="flex flex-1 flex-col gap-2">
                  <div className="font-bold">{section?.BackgroundTypeSectionTitle}</div>
                  <div className="text-vpGray-700">{section?.BackgroundTypeSectionSubtitle}</div>
                </div>
                <div className="flex flex-col gap-10 lg:flex-row">
                  {section?.BackgroundTypeRadios?.map((radio: any) => {
                    return (
                      <Radio
                        checked={settings?.backgroundType === radio?.Value}
                        className="flex-1"
                        id={radio?.HtmlId}
                        key={radio?.id}
                        label={radio?.Label}
                        name={radio?.Name}
                        onChange={() => {
                          onSettingsChange?.({
                            backgroundType: radio?.Value,
                          });
                        }}
                        value={radio?.Value}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Simulator
        className="w-1/3"
        widgetProps={{
          id: "style-page-widget",
          ...settings,
        }}
      />
    </div>
  );
};

export default StylePage;
